import { Injectable } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, map, mergeMap, Observable, of, tap } from 'rxjs';

import { ICurrentUser } from '../interfaces';
import { GetUserAccessUseCase } from '../use-cases';
import { UserAccessResponseModel, UserRoleType, UserTypeResponseModel } from '../models';

@Injectable()
export class CurrentUserService implements ICurrentUser {
    private authorizationResponse: UserAccessResponseModel = new UserAccessResponseModel();
   
    constructor(
        private oauthService: OidcSecurityService,
        private getUserAccessUseCase: GetUserAccessUseCase) {
    }

    get isLoggedIn() {
        return this.oauthService.isAuthenticated()
            .pipe(
                catchError((error) => {
                    console.error("Authentication error", error);
                    return of(false);
                }),
            );
    }

    get accessToken(): Observable<string> {
        return this.oauthService.getAccessToken();
    }

    get idToken(): Observable<string> {
        return this.oauthService.getIdToken();
    }

    get name(): Observable<string> {
        return this.oauthService.getPayloadFromIdToken()
            .pipe(
                map(result => {
                    const email = result.email as string;
                    return email.substring(0, email.lastIndexOf("@"))
                }));
    }

    get roles(): UserRoleType[] {
        return this.authorizationResponse.roles;
    }

    public get access(): UserTypeResponseModel[] {
        return this.authorizationResponse.userTypes;
    }

    public logIn(): Observable<boolean> {
        return this.oauthService.checkAuth()
            .pipe(
                mergeMap(response => {
                    if (response.isAuthenticated === false) {
                        return of(this.oauthService.authorize());
                            //.pipe(mergeMap(() => this.getUserAccessUseCase.execute()));
                    }
                    return this.getUserAccessUseCase.execute();
                }),
                map(authorizationResponse => {
                    if (authorizationResponse) {
                        this.authorizationResponse = authorizationResponse;
                    }
                    else {
                        throw new Error(`Invalid user authorization.`);
                    }
                }),
                mergeMap(() => {
                    return this.isLoggedIn;
                }));
    }

    public logOut() {
        return this.oauthService.logoffAndRevokeTokens()
            .pipe(tap(() => {
                sessionStorage.clear();
            }));
    }
}
